import DashboardAppointments from 'components/appointments/DashboardAppointments';
import React from 'react';

const Appointments = () => {
  return <DashboardAppointments />;
};

export default Appointments;
